import { ifAuthenticated, mustBeUser } from "../util/auth";

const PersonalDetails = () =>
  import("../components/content/employeeportal/personalDetails");
const JobPay = () => import("../components/content/employeeportal/jobPay");
const DocumentsUpload = () =>
  import("../components/content/employeeportal/documentsUpload");
const Payslip = () => import("../components/content/employeeportal/payslip");
const Leave = () => import("../components/content/employeeportal/leave");
const Queries = () => import("../components/content/employeeportal/queries");
const ViewQuery = () =>
  import("../components/content/employeeportal/viewQuery");
const Layout = () => import("../components/content/employeeportal/layout");

export const employeePortalRoutes = {
  path: "/employee-portal",
  component: Layout,
  children: [
    {
      path: "",
      component: PersonalDetails
    },
    {
      path: "/personal-details",
      component: PersonalDetails
    },
    {
      path: "/job-pay",
      component: JobPay
    },
    {
      path: "/documents-upload",
      component: DocumentsUpload
    },
    {
      path: "/payslip",
      component: Payslip
    },
    {
      path: "/leave",
      component: Leave
    },
    {
      path: "/queries",
      component: Queries
    },
    {
      path: "/queries/:id",
      name: "ViewMyQuery",
      component: ViewQuery
    }
  ],
  // beforeEnter: ifAuthenticated
  beforeEnter: mustBeUser
};
